import Link from 'next/link';

import FloatingForm from './forms/FloatingForm';
import StandardForm from './forms/StandardForm';
import FormSizes from './forms/FormSizes';
import UploadForm from './forms/UploadForm';
import CheckboxesRadios from './forms/CheckboxesRadios';
import FormSelect from './forms/FormSelect';

const Forms = () => {
  return (
    <>
      <h1>Formulare</h1>
      <p className="lead">
        Formelemente sind in drei unterschiedlichen Grössen verfügbar,
        dargestellt im Tab <code>Form Sizes</code>. Die klassischen Select
        Optionen sind mit dem jQuery-Plugin{' '}
        <Link href="https://select2.org/" legacyBehavior>
          <a target="_blank">Select2</a>
        </Link>{' '}
        realisiert. Die Select Listen sind in zwei unterschiedlichen Grössen
        verfügbar. Für die <code>Labels</code> gibt es zwei Varianten.
        Vergleichen Sie die Varianten im Tab <code>Standard Form</code> und im
        Tab <code>Form Floating</code>.
      </p>
      {/* Tabs */}
      <ul className="nav nav-tabs mt-5" id="myTab" role="tablist">
        <li className="nav-item" role="presentation">
          <button
            className="nav-link active"
            id="standard-tab"
            data-bs-toggle="tab"
            data-bs-target="#standard-tab-pane"
            type="button"
            role="tab"
            aria-controls="standard-tab-pane"
            aria-selected="false"
          >
            Standard Form
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className="nav-link"
            id="floating-tab"
            data-bs-toggle="tab"
            data-bs-target="#floating-tab-pane"
            type="button"
            role="tab"
            aria-controls="floating-tab-pane"
            aria-selected="true"
          >
            Form Floating
          </button>
        </li>

        <li className="nav-item" role="presentation">
          <button
            className="nav-link"
            id="upload-tab"
            data-bs-toggle="tab"
            data-bs-target="#upload-tab-pane"
            type="button"
            role="tab"
            aria-controls="upload-tab-pane"
            aria-selected="false"
          >
            Form Upload
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className="nav-link"
            id="sizes-tab"
            data-bs-toggle="tab"
            data-bs-target="#sizes-tab-pane"
            type="button"
            role="tab"
            aria-controls="sizes-tab-pane"
            aria-selected="false"
          >
            Form Sizes
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className="nav-link"
            id="checkboxes-tab"
            data-bs-toggle="tab"
            data-bs-target="#checkboxes-tab-pane"
            type="button"
            role="tab"
            aria-controls="checkboxes-tab-pane"
            aria-selected="false"
          >
            Checkboxes & Radios
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className="nav-link"
            id="select-tab"
            data-bs-toggle="tab"
            data-bs-target="#select-tab-pane"
            type="button"
            role="tab"
            aria-controls="select-tab-pane"
            aria-selected="false"
          >
            Select
          </button>
        </li>
      </ul>
      {/* Tabs content */}
      <div className="tab-content" id="myTabContent">
        <div
          className="tab-pane fade show active"
          id="standard-tab-pane"
          role="tabpanel"
          aria-labelledby="standard-tab"
          tabIndex={0}
        >
          <StandardForm />
        </div>
        <div
          className="tab-pane fade"
          id="floating-tab-pane"
          role="tabpanel"
          aria-labelledby="floating-tab"
          tabIndex={0}
        >
          <FloatingForm />
        </div>

        <div
          className="tab-pane fade"
          id="upload-tab-pane"
          role="tabpanel"
          aria-labelledby="upload-tab"
          tabIndex={0}
        >
          <UploadForm />
        </div>
        <div
          className="tab-pane fade"
          id="sizes-tab-pane"
          role="tabpanel"
          aria-labelledby="sizes-tab"
          tabIndex={0}
        >
          <FormSizes />
        </div>
        <div
          className="tab-pane fade"
          id="checkboxes-tab-pane"
          role="tabpanel"
          aria-labelledby="checkboxes-tab"
          tabIndex={0}
        >
          <CheckboxesRadios />
        </div>
        <div
          className="tab-pane fade"
          id="select-tab-pane"
          role="tabpanel"
          aria-labelledby="select-tab"
          tabIndex={0}
        >
          <FormSelect />
        </div>
      </div>
    </>
  );
};

export default Forms;
